import { useDataChange } from 'Simple/Data.js'

function stripHtmlTags(str) {
  if (typeof str !== 'string') return ''
  return str.replace(/<[^>]*>/g, '')
}

function replaceMergeFields(str) {
  if (typeof str !== 'string') return ''
  // approximate merge field
  return str.replace(/\{[^}]+\}/g, 'xxxxxxxx')
}

/*
 This is for SMS notification templates. 
 They are charged according to number of segments used.
 https://www.twilio.com/en-us/blog/what-the-heck-is-a-segment-html
 this function calculates that and show a warning if they use more than 2 segments.
*/
function calculateSmsSegments(message) {
  let gsm7Characters =
    '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ\fÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?' +
    '¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà'

  let gsm7Extended = '^{}\\[~]|€'

  let gsm7Set = new Set(gsm7Characters + gsm7Extended)

  let formattedMessage = stripHtmlTags(replaceMergeFields(message))
  let totalCharacters = formattedMessage.length
  let isGsm7 = Array.from(formattedMessage).every(char => gsm7Set.has(char))

  let singleSegmentLimit, multiSegmentLimit

  if (isGsm7) {
    singleSegmentLimit = 160
    multiSegmentLimit = 153
  } else {
    singleSegmentLimit = 70
    multiSegmentLimit = 67
  }

  if (totalCharacters <= singleSegmentLimit) {
    return 1
  } else {
    return Math.ceil(totalCharacters / multiSegmentLimit)
  }
}

export function useDataOnChange(props) {
  let change = useDataChange({
    context: 'event_action',
    viewPath: props.viewPath,
    path: 'data.sms_template.content',
  })

  let changeSegments = useDataChange({
    context: 'editor',
    viewPath: props.viewPath,
    path: 'segments',
  })
  return function onChange(value) {
    change(stripHtmlTags(value))
    changeSegments(calculateSmsSegments(value))
  }
}
